import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

const PATH_TEMPLATE = '/auth/anonymous-user';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Output = THIS_API['response'];

const createAnonymousUser = async (): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE);
  const response = await noodleApiClient.post(path);
  return response.data;
};

export default createAnonymousUser;
